var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"gl-align-middle",attrs:{"variant":_vm.workItemStateVariant,"icon":_vm.workItemStateIcon}},[_vm._v("\n  "+_vm._s(_vm.stateText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }